import Vue from "vue";
import VueRouter from "vue-router";
import Primary from "../views/Primary/index.vue";
import Success from "../views/Success.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/primary/1",
  },
  {
    path: "/primary/:id",
    name: "Primary",
    component: Primary,
    meta: {
      title: "【希望学】课程报名",
    },
  },
  {
    path: "/success",
    name: "Success",
    component: Success,
    meta: {
      title: "【希望学】课程报名",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
